import { useEffect, useState } from 'react';
import { Card, CardContent, CardMedia, CardActionArea, Box, Typography, Grid, Button } from '@mui/material';
import { CSVLink } from 'react-csv';

const ResultsPane = (props) => {
    const [ maxResultsCount, setMaxResultsCount ] = useState(12);

    useEffect(() => {
        loadProjects();
        loadOrganisations();
        loadTechProviders();
    }, []);

    useEffect(() => {
        if (props.refreshList) {
            loadProjects();
            props.setRefreshList(false);
        }
    }, [props.refreshList])

    const loadProjects = async () => {
        let { data } = await props.db
            .schema('api')
			.from('projects')
			.select('*')
            .is('approved', props.admin === true ? false : true);
        props.setProjects(data || []);
        //if (props.admin === true) {
          props.setFilteredProjects(data || []);
        //}
        //console.log(data);
    };

    const loadOrganisations = async () => {
        let { data } = await props.db
            .schema('api')
			.from('organisations')
			.select('*');
        data.forEach((i) => {i.label = i.name});
        props.setOrganisations(data || []);
        //console.log(data);
    };

    const loadTechProviders = async () => {
        let { data } = await props.db
            .schema('api')
			.from('tech_providers')
			.select('*');
        data.forEach((i) => {i.label = i.name});
        props.setTechProviders(data || []);
        //console.log(data);
    };

    const getOrganisationName = (id) => {
        if (props.organisations && props.organisations.length > 0) {
            let org = props.organisations.find(o => o.id === id);
            if (org) {
                return org.name;
            }
        }
        return "";
    };

    const getTechProviderName = (id) => {
        if (props.techProviders && props.techProviders.length > 0) {
            let tp = props.techProviders.find(o => o.id === id);
            if (tp) {
                return tp.name;
            }
        }
        return "";
    };
    
    return (
        <div style={{padding:20}}>
        <Grid container spacing={2}>
            <Grid size={12} >
            <p style={{color: 'black', width: '100%', marginLeft: '20px'}}>There are {props.filteredProjects.length} projects that match your search&nbsp;
                { props.filteredProjects.length > 0 && <CSVLink style={{color: '#A2D9E7'}} data={props.filteredProjects}>(download selection)</CSVLink>
                }:</p>
            </Grid>
    {props.filteredProjects.slice(0, maxResultsCount).map((item) => (
        <Grid size={{xs:12, sm:6, md:4, lg:3, xl:2}} key={`ResultsGrid2${item.id}`}>
        <Card sx={{ display: "flex", width: '100%', height: '100%', boxShadow: '5px 5px 5px 5px rgba(0, 0, 0, 0.25)', borderRadius: 0 }} key={`ResultsCard2${item.id}`}>
            <CardActionArea
                onClick={() => props.onSelectResult(item)}
                sx={{ height: "100%"}}
                >
                <CardContent sx={{ padding: 1, height: "100%", overflow: "hidden"}}>
                        <Box sx={{display: 'flex', flexDirection: 'column', padding: '5px'}}>
                            <Typography variant="h5" color="#0b7dbb" fontWeight={'bold'}>
                                {item.project_name}
                            </Typography>
                            <Typography variant="body2" color="textSecondary" sx={{whiteSpace: 'pre-wrap', paddingTop: '5px'}}>
                                Lead Organisation:{<br/>}
                            </Typography>
                            <Typography variant="body1">
                                {getOrganisationName(item.owner)}
                            </Typography>
                            <Typography variant="body2" color="textSecondary" sx={{whiteSpace: 'pre-wrap', paddingTop: '5px'}}>
                                Technology Providers:{<br/>}
                            </Typography>
                            <Typography variant="body1">
                                {Array.from(item.tech_providers, (i) => getTechProviderName(i)).join(", ")}
                            </Typography>
                            <Typography variant="body2" color="textSecondary" sx={{whiteSpace: 'pre-wrap', paddingTop: '5px'}}>
                                SAFET Theme:{<br/>}
                            </Typography>
                            <Typography variant="body1" component={'span'}>
                                <ul style={{marginTop: 0, marginBottom: 1}}>
                                {item.safet_theme.map((li) => (<li key={li}>{li}</li>))}
                                </ul>
                            </Typography>
                            <Typography variant="body2" color="textSecondary" sx={{whiteSpace: 'pre-wrap', paddingTop: '5px'}}>
                                Technologies Used:{<br/>}
                            </Typography>
                            <Typography variant="body1" component={'span'}>
                                <ul style={{marginTop: 0, marginBottom: 1}}>
                                {item.technology_types.map((li) => (<li key={li}>{li}</li>))}
                                </ul>
                            </Typography>
                            <Typography variant="body2" color="textSecondary" sx={{whiteSpace: 'pre-wrap', paddingTop: '5px'}}>
                                SDGs:{<br/>}
                            </Typography>
                            <Typography variant="body1">
                                {item.sdgs.map((s) => <img key={`/sdg${s}.png`} style={{padding: '2px'}} width="50px" src={`/sdg${s}.png`}/>)}
                            </Typography>
                        </Box>
                </CardContent>
            </CardActionArea>
        </Card>
        </Grid>
    ))}
    <Grid size={12} sx={{display: 'flex', justifyContent: 'center', marginTop: 2}}>
        { maxResultsCount < props.filteredProjects.length && (
            <Button variant="contained" onClick={() => setMaxResultsCount(prev => prev + 6)}>Load more</Button>
        )}
    </Grid>
    </Grid>
    </div>
    );
};

export default ResultsPane;